// From npm module
import 'core-js/fn/dom-collections/iterator'
import 'core-js/fn/array/from'
import 'core-js/fn/object/assign'
import 'core-js/es6/promise'
import 'core-js/es6/symbol'
import 'eligrey-classlist-js-polyfill'
